import { LoginBonusKind } from '../../../../services/exports/Constants';
import useMobileAppSignupBonus from './handlers-by-kind/useMobileAppSignupBonus';
import { LoginBonusHandler } from '../../types';

const useGetHandlerByKind = () => {
  // welcome_bonus has no UI side effect (its conversion is tracked in AnalyticsProvider),
  // so the map is partial and the caller null-checks the resolved handler.
  const handlersByKind: Partial<Readonly<Record<LoginBonusKind, ReturnType<LoginBonusHandler>>>> = {
    [LoginBonusKind.MobileAppSignupBonus]: useMobileAppSignupBonus(),
  };

  return (kind: LoginBonusKind) => handlersByKind[kind];
};

export default useGetHandlerByKind;
